/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $OwnerViewDocumentResponse = {
    properties: {
        active: {
    type: 'array',
    contains: {
        type: 'EmployeeDocumentByDocumentIdResponse',
    },
    isRequired: true,
},
        archive: {
    type: 'array',
    contains: {
        type: 'EmployeeDocumentByDocumentIdResponse',
    },
    isRequired: true,
},
    },
};